import { useEffect } from "react";
import { notification } from "antd";
import "./NotificationToast.css";
import { isDevelopment } from "src/module/helpers";

const allowed_notif = ["success", "info", "warning", "error"];

const NotificationToast = () => {
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    const handleShowToast = (event) => {
      const notificationData = event.detail;

      if (isDevelopment) console.log(notificationData);

      const type = notificationData?.data?.type || "info";
      let notifType = type === "onu_detection" ? "info" : type;

      if (!allowed_notif.includes(notifType)) {
        notifType = "info"; // safer default
      }

      // React 18 safe trigger
      Promise.resolve().then(() => {
        api.open({
          type: notifType,
          message: notificationData.title,
          description: notificationData.body,
          duration: 10,
          placement: "bottomRight",
          className: "custom-toast",
          maxCount: 4,
          onClick: () => {
            if (notificationData.data?.url) {
              window.open(notificationData.data.url, "_blank");
            }
          },
        });
      });
    };

    window.addEventListener("show-toast", handleShowToast);
    return () => window.removeEventListener("show-toast", handleShowToast);
  }, [api]);

  return <>{contextHolder}</>;
};

export default NotificationToast;
